import { Transition } from '@headlessui/react'
import { useNavigate } from 'react-router'
import { useShallow } from 'zustand/react/shallow'

import { DestinationForm } from '@ui/pages/destinations/components/DestinationForm'
import { Wizard } from '@ui/pages/pipelinesWorkflow/components/Export/Wizard'
import { useNavigationStateStore } from '@ui/stores'

export const NewDestination = () => {
  const navigate = useNavigate()
  const { instanceId } = useNavigationStateStore(useShallow((state) => state.params))

  const returnToDestinations = () => navigate(`/instances/${instanceId}/destinations`)

  return (
    <Transition
      show
      enter="transition-opacity duration-75"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-150"
      leaveFrom="opacity-100"
      leaveTo="opacity-0">
      <div className="relative z-50 h-full overflow-hidden">
        <Wizard />
        <DestinationForm onCancel={returnToDestinations} onCreate={returnToDestinations} />
      </div>
    </Transition>
  )
}
